export default __webpack_public_path__ + "49a7a675345313252c5dd4b07780493f.png";